import { render, staticRenderFns } from "./TenderVisitsTable.vue?vue&type=template&id=2c54d737"
import script from "./TenderVisitsTable.vue?vue&type=script&lang=js"
export * from "./TenderVisitsTable.vue?vue&type=script&lang=js"
import style0 from "./TenderVisitsTable.vue?vue&type=style&index=0&id=2c54d737&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports